<div class="lenses-table__container">
  <table #lensesTableEl mat-table [dataSource]="dataSource" class="lenses-table" [trackBy]="trackByFn">
    <!-- Setting Name Column -->
    <ng-container matColumnDef="setting" sticky>
      <th mat-header-cell *matHeaderCellDef>Setting</th>
      <td mat-cell *matCellDef="let row">
        <div class="setting-name">
          {{ row.name }}
          @if (row?.description) {
            <div class="setting-desc">{{ row.description }}</div>
          }
        </div>
      </td>
    </ng-container>

    <!-- Dynamic Lens Columns -->
    @for (lensTitle of displayedColumns.slice(1); track lensTitle) {
      <ng-container [matColumnDef]="lensTitle">
        <th mat-header-cell *matHeaderCellDef>
          <div
            class="lenses-table__lens-actions"
            [ngClass]="{'lenses-table__lens-actions--show-menu': lensTitle !== defaultLensColumnTitle}"
          >
            <span> {{ lensTitle }}</span>
            @if (lensTitle !== defaultLensColumnTitle) {
              <list-view-menu [options]="menuOptions" (action)="onMenu($any($event), lensTitle)" />
            }
          </div>
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="setting-toggle-container">
            <oph-slide-toggle
              class="setting-slide-toggle"
              [disabled]="isLoading()"
              [checked]="row.lenses[lensTitle]?.value"
              (toggle)="toggleSetting(lensTitle, row, $event)"
            />
          </div>
        </td>
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr *matNoDataRow>
      <td class="lenses-table__empty" [attr.colspan]="displayedColumns.length">No settings found.</td>
    </tr>
  </table>
</div>
